import { IMAGES, img } from "../data/content";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

export const Story = () => (
  <Section id="story" className="overflow-visible">
    <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
      <Reveal className="relative order-2 lg:order-1">
        <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-[#d4af37]/30" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src={img(IMAGES.interior, 1100)}
            alt="A warmly lit café diner interior with wooden furniture"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="absolute -bottom-10 -right-4 hidden w-48 overflow-hidden rounded-xl border border-[rgba(247,244,239,0.15)] shadow-[0_16px_40px_rgba(0,0,0,0.5)] sm:block md:w-56">
          <img
            src={img(IMAGES.lights, 600)}
            alt="Café lights glowing in the evening"
            className="aspect-square w-full object-cover"
            loading="lazy"
          />
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="eyebrow mb-4">Our Story</p>
          <h2 className="font-display text-4xl font-semibold leading-[1.08] tracking-tight text-[#f7f4ef] sm:text-5xl">
            A room above the city's hum
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 text-base leading-relaxed text-[#b5afa7] md:text-lg">
            Perched on the second floor of Swastik Plaza, near Ravidas Gate in Lanka, Roma's Café
            Diner is part café, part old-school diner — warm lamplight, well-worn textures, and the
            unhurried rhythm of a place built for lingering.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#b5afa7] md:text-lg">
            The idea is simple: coffee poured with care, plates that comfort, and a room where
            students, neighbours and travellers all find their corner. Come up the stairs, leave the
            rush at the door.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <blockquote className="font-display mt-9 border-l-2 border-[#d4af37] pl-6 text-xl italic leading-relaxed text-[#e8e2d8] md:text-2xl">
            "A café should feel like a long exhale at the end of a Varanasi day."
          </blockquote>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#8f887f]">
            — The spirit of Roma's
          </p>
        </Reveal>
      </div>
    </div>
  </Section>
);
